<div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="pagination && (pagination.pages > 0)"
  class="paginator-bar-height">
  <ion-button class="action-button-paging" [disabled]="pagination.hideLeft" (click)="switchPage(-1)">
    <icon-wrapper slot="icon-only" icon="arrow-back"></icon-wrapper>
  </ion-button>
  <span class="info-text-xs text-color-primary" tappable (click)="openPaginateSelector()">page {{pagination.pageDisp}}
    of
    {{pagination.pages}}</span>
  <ion-button class="action-button-paging" [disabled]="pagination.hideRight" (click)="switchPage(1)">
    <icon-wrapper slot="icon-only" icon="arrow-forward"></icon-wrapper>
  </ion-button>
</div>